enum BlogType{
    None = 0,
    Blog = 1,
    Offer = 2
}

export default BlogType

